import React from "react";
import { inr, pct } from "@/lib/format";

export function KpiCard({ label, value, sublabel, tone = "neutral", format = "inr", testid, compact = false }) {
  const formatted =
    format === "inr" ? inr(value, { compact }) :
    format === "pct" ? pct(value) :
    format === "num" ? new Intl.NumberFormat("en-IN").format(value || 0) :
    format === "x"   ? `${(value || 0).toFixed(2)}x` :
    value;

  const toneClass =
    tone === "positive" ? "text-[hsl(var(--positive))]" :
    tone === "negative" ? "text-[hsl(var(--negative))]" :
    "text-foreground";

  return (
    <div className="p-6 flex flex-col justify-between min-h-[130px]" data-testid={testid}>
      <div className="overline text-muted-foreground">{label}</div>
      <div className="mt-4">
        <div className={`font-mono text-3xl font-semibold tracking-tight tabular-nums ${toneClass}`}>{formatted}</div>
        {sublabel && <div className="text-xs text-muted-foreground mt-1 font-mono">{sublabel}</div>}
      </div>
    </div>
  );
}
